module.exports = __webpack_public_path__ + "img/etc.364a60fc.svg";